module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Janice Maynard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('I', [_vm._v("USA TODAY")]), _vm._v(" bestselling author Janice Maynard loved books and writing even as a child. Now, creating sexy, character-driven romances is her day job! She has written more than 75 books and novellas which have sold, collectively, almost three million copies. Janice lives in the shadow of the Great Smoky Mountains with her husband, Charles. They love hiking, traveling, and spending time     with family. "), _c('Br', [_c('Br', [_vm._v("Connect with Janice at www.JaniceMaynard.com and on all socials.")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/e6Iq0d/tc-custom/9781460324035.jpg?1718182734986",
      "alt": "This image is the cover for the book Beneath the Stetson, Texas Cattleman's Club: The Missing Mogul"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beneath the Stetson, Texas Cattleman's Club: The Missing Mogul\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this Texas Cattleman's Club tale, USA TODAY bestselling author Janice Maynard brings you the sexiest single dad in Royal, Texas! "), _c('br'), _c('br'), _vm._v("Millionaire rancher Gil Addison does "), _c('i', [_vm._v("not")]), _vm._v(" need Bailey Collins. She is far from the sweet homemaker he thought he wanted. But she "), _c('i', [_vm._v("is")]), _vm._v(" a beautiful woman with a badge, hot on the heels of a kidnapper in Gil's club. And Gil is hot for her! "), _c('br'), _c('br'), _vm._v("Bailey can't let her career get sidetracked by the cowboy and his son. She's here to do a job, not find a family. Bailey won't stop till she gets her man in cuffs. Trouble is, Gil won't stop till he gets this woman in his bed!")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0